/* istanbul ignore file */
export { default } from './ImageCarousel';
